import React from "react";

/* =========================================================
   KpiCard
   Small reusable stat card - "Active Targets: 4" style tiles
   used on MyTarget, TargetManagement, and admin dashboards.
========================================================= */
function KpiCard({ label, value, icon, accent = "indigo", sub }) {
  return (
    <div className={`kpi-card-mini accent-${accent}`}>
      {icon && <div className="kpi-mini-icon">{icon}</div>}
      <div className="kpi-mini-value">{value}</div>
      <div className="kpi-mini-label">{label}</div>
      {sub && <div className="kpi-mini-sub">{sub}</div>}
    </div>
  );
}

export default KpiCard;
